import { type ChangeEvent, type Dispatch, type SetStateAction } from 'react'

import { type TMainCategoryData } from '@App/types/servicesTypes'

import style from './NameTitle.module.scss'

interface IProps {
    isEdit: boolean
    name: string
    editableSection: TMainCategoryData | null
    setEditableSection: Dispatch<SetStateAction<TMainCategoryData | null>>
}

export const NameTitle = (props: IProps) => {
    const { name, isEdit, editableSection, setEditableSection } = props

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) =>
        setEditableSection((prev) => prev && { ...prev, name: e.target.value })

    const onRenderNameByEditMode = () => {
        if (isEdit && editableSection) {
            return (
                <div className={style.inputContainer}>
                    <input name='edit-category-name' value={editableSection.name} onChange={onChangeHandler} />
                </div>
            )
        } else {
            return (
                <div className={style.titleContainer}>
                    <span>{name}</span>
                </div>
            )
        }
    }

    return onRenderNameByEditMode()
}
